var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dara-image',{staticClass:"p--lg el-avatar--circle",class:_vm.classList,staticStyle:{"pointer-events":"none !important"},style:(_vm.styles),attrs:{"fit":"cover","src":_vm.image,"height":_vm.size,"width":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }